/** @jsxImportSource @emotion/react */
import { PageWrapper } from "../../components/page-skeleton/PageWrapper";
import { CardContainer } from "../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../components/page-skeleton/PageHeader";
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";
import { useGetIntegrations } from "./service/integrations-api";
import { IntegrationsTable } from "./components/IntegrationsTable";
import { CardBody } from "../../components/page-skeleton/CardBody";
import { css } from "@emotion/react";
import { SpinnerBlock } from "../common/Spinner";
import { MutateIntegrationSelector } from "./components/MutateIntegrationSelector";
import { useHandleFetchError } from "../../error-handler";

const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

export const IntegrationsList = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data, isLoading, error } = useGetIntegrations(organizationKeyName);

  useHandleFetchError(error);

  if (isLoading) {
    return <SpinnerBlock />;
  }

  return (
    <PageWrapper>
      <CardContainer>
        <PageHeader
          title="Integrations"
          subtitle="Manage all of your 3rd party integrations"
        >
          <MutateIntegrationSelector />
        </PageHeader>
        {data?.length === 0 || !data ? (
          <CardBody additionalStyles={cardBodyAdditionalStyling}>
            <></>
          </CardBody>
        ) : (
          <IntegrationsTable integrations={data} />
        )}
      </CardContainer>
    </PageWrapper>
  );
};
